import ConsumerRefService from "@api/consumer/consumerRefService";
import {IGoal} from "@interfaces/consumer/refs";
import {FC, useCallback} from "react";
import {toastr} from "@/utils/toastHelper";
import {ConditionType, GoalFormValues} from "./forms/goalBaseInfoBlock";
import GoalForm from "./goalForm";

interface EditGoalFormProps {
    goal: IGoal;
}

const EditGoalForm: FC<EditGoalFormProps> = ({goal}) => {

    const initialValues: GoalFormValues = {
        name: goal.name,
        description: goal.description || '',
        isActive: goal.isActive,
        order: goal.order,
        conditionType: goal.allConditions ? ConditionType.All : ConditionType.One,
        hidden: goal.hidden,
        groupIds: goal.groupIds || []
    }

    const onSubmit = useCallback(async (values: GoalFormValues) => {
        const api = new ConsumerRefService();
        const result = await api.patchGoal({
            id: goal.id,
            name: values.name,
            description: values.description,
            isActive: values.isActive,
            order: values.order,
            allConditions: values.conditionType === ConditionType.All,
            hidden: values.hidden,
            groupIds: values.groupIds
        });

        if (result.success) {
            toastr.success("Изменение достижения", "Достижение успешно обновлено");
        }
        else {
            if (result.errorCode === 'GoalNotFound') {
                toastr.error('Изменение достижения', 'Достижение не найдено');
            }
            else {
                toastr.error('Изменение достижения', 'Неизвестная ошибка');
            }
        }
    }, [goal.id]);

    const onDelete = useCallback(async () => {
        const api = new ConsumerRefService();
        const result = await api.deleteGoal(goal.id);

        if (result.success) {
            toastr.success("Удаление достижения", "Достижение успешно удалено");
        }
        else {
            if (result.errorCode === 'GoalNotFound') {
                toastr.error('Удаление достижения', 'Достижение не найдено');
            }
            else {
                toastr.error('Удаление достижения', 'Неизвестная ошибка');
            }
        }
    }, [goal.id]);

    return (
        <GoalForm
            initialValues={initialValues}
            onSubmit={onSubmit}
            onDelete={onDelete}
            editForm={true}
            cancelUrl={`/consumer/goals/${goal.id}/`}
        />
    )
}

export default EditGoalForm;
